export default "__VITE_ASSET__BqSUZBoB__"